// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Nanoid from "nanoid";
import * as Row$Catalyst from "../../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingContext from "../../../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as MuiLoader$Catalyst from "../../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/MuiLoader.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as ModificationsContext from "../../../../../library/modifications-context/ModificationsContext.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as PricingDashboardDataMachine from "../../../../../../../app/PricingDashboardDataMachine.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../../assets/PricingDashboardAssetsManager.bs.js";
import * as ModificationListFooterStateMachine from "./ModificationListFooterStateMachine.bs.js";
import * as UpdateModificationConfirmationModal from "../../../../modals/UpdateModificationConfirmationModal.bs.js";

var error_sign = PricingDashboardAssetsManager.getImage("error-sign.svg");

function ModificationListViewFooter$ActionButtons(Props) {
  var is_submit_disabledOpt = Props.is_submit_disabled;
  var resetCb = Props.resetCb;
  var submitCb = Props.submitCb;
  var is_submit_disabled = is_submit_disabledOpt !== undefined ? is_submit_disabledOpt : false;
  return React.createElement(React.Fragment, undefined, React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Text */0,
                        _0: "Reset All"
                      }, undefined, (function (param) {
                          return Curry._1(resetCb, undefined);
                        }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined),
                  key: Nanoid.nanoid()
                }), React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Text */0,
                        _0: "Submit"
                      }, is_submit_disabled, (function (param) {
                          return Curry._1(submitCb, undefined);
                        }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined),
                  key: Nanoid.nanoid()
                }));
}

var ActionButtons = {
  make: ModificationListViewFooter$ActionButtons
};

function getErrorString(err) {
  return err._0.message;
}

function getEditedModificationPayload(edited_modifications, core_pricing_external_id, initial_priority) {
  return {
          core_pricing_external_id: core_pricing_external_id,
          updated_modifications: List.map((function (external_id) {
                  return {
                          external_id: external_id,
                          status: edited_modifications[external_id]
                        };
                }), $$Array.to_list(Object.keys(edited_modifications))),
          prioritized_modification_ids: initial_priority
        };
}

function getReprioritizeModificationsPayload(modified_priorities, core_pricing_external_id) {
  return {
          core_pricing_external_id: core_pricing_external_id,
          modification_ids: modified_priorities
        };
}

function getActionCb(action_type, reset_list, refetchModifications, core_pricing_external_id, openSnackbar, closeConfirmationModal, dispatch) {
  var match = ModificationsContext.useContext(undefined);
  var edited_modifications = match.edited_modifications;
  var initial_priorities = match.initial_priorities;
  var modified_priorities = match.modified_priorities;
  if (action_type) {
    return function (param) {
      Curry._1(closeConfirmationModal, undefined);
      Curry._1(dispatch, /* SetSubmitting */1);
      var partial_arg = {
        core_pricing_external_id: core_pricing_external_id,
        modification_ids: modified_priorities
      };
      return function (param) {
        return PricingDashboardDataMachine.reprioritizeModification(partial_arg, (function (param) {
                      Curry._1(dispatch, /* Reset */0);
                      Curry._1(reset_list, undefined);
                      Curry._1(refetchModifications, undefined);
                      return Curry._1(openSnackbar, {
                                  TAG: /* Success */0,
                                  _0: "New priorities have been assigned and sent for approval"
                                });
                    }), (function (err) {
                      return Curry._1(dispatch, {
                                  TAG: /* SetPrioritiseError */0,
                                  _0: err
                                });
                    }), param);
      };
    };
  } else {
    return function (param) {
      Curry._1(dispatch, /* SetSubmitting */1);
      Curry._1(closeConfirmationModal, undefined);
      var partial_arg = getEditedModificationPayload(edited_modifications, core_pricing_external_id, initial_priorities);
      return function (param) {
        return PricingDashboardDataMachine.editModification(partial_arg, (function (param) {
                      Curry._1(dispatch, /* Reset */0);
                      Curry._1(reset_list, undefined);
                      Curry._1(refetchModifications, undefined);
                      return Curry._1(openSnackbar, {
                                  TAG: /* Success */0,
                                  _0: "Modification statuses have been updated successfully"
                                });
                    }), (function (err) {
                      return Curry._1(dispatch, {
                                  TAG: /* SetUpdateStatusError */1,
                                  _0: err
                                });
                    }), param);
      };
    };
  }
}

function ModificationListViewFooter(Props) {
  var open_create_modification_modal = Props.open_create_modification_modal;
  var reset_list = Props.reset_list;
  var core_pricing_external_id = Props.core_pricing_external_id;
  var is_submit_disabled = Props.is_submit_disabled;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ModificationsContext.useContext(undefined);
  var match$2 = CorePricingContext.useContext(undefined);
  var match$3 = React.useReducer(ModificationListFooterStateMachine.reducer, /* Init */0);
  var dispatch = match$3[1];
  var state = match$3[0];
  var match$4 = React.useState(function () {
        
      });
  var toggleConfirmationModal = match$4[1];
  var action = match$4[0];
  var match$5 = ModificationsContext.useContext(undefined);
  var edited_modifications = match$5.edited_modifications;
  var modified_priorities = match$5.modified_priorities;
  React.useEffect((function () {
          if (modified_priorities) {
            Curry._1(dispatch, /* SetPrioritising */2);
          }
          
        }), [modified_priorities]);
  React.useEffect((function () {
          var match = Object.keys(edited_modifications);
          if (match.length !== 0) {
            Curry._1(dispatch, /* SetUpdatingStatus */3);
          }
          
        }), [Object.keys(edited_modifications)]);
  var tmp;
  var exit = 0;
  switch (match$2.role.TAG | 0) {
    case /* BusinessAdmin */0 :
    case /* CityAdmin */1 :
        exit = 1;
        break;
    case /* User */2 :
        tmp = null;
        break;
    
  }
  if (exit === 1) {
    if (typeof state === "number") {
      switch (state) {
        case /* Init */0 :
            tmp = React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Text */0,
                        _0: "Create Modification"
                      }, undefined, (function (param) {
                          return Curry._1(open_create_modification_modal, undefined);
                        }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined),
                  key: Nanoid.nanoid()
                });
            break;
        case /* Submitting */1 :
            tmp = React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "submitting-action"
                }, React.createElement(MuiLoader$Catalyst.make, {}), React.createElement("div", undefined, "Submitting"));
            break;
        case /* Prioritising */2 :
            tmp = React.createElement(ModificationListViewFooter$ActionButtons, {
                  resetCb: (function (param) {
                      Curry._1(reset_list, undefined);
                      return Curry._1(dispatch, /* Reset */0);
                    }),
                  submitCb: (function (param) {
                      return Curry._1(toggleConfirmationModal, (function (param) {
                                    return /* Reprioritize */1;
                                  }));
                    })
                });
            break;
        case /* UpdatingStatus */3 :
            tmp = React.createElement(ModificationListViewFooter$ActionButtons, {
                  is_submit_disabled: is_submit_disabled,
                  resetCb: (function (param) {
                      Curry._1(reset_list, undefined);
                      return Curry._1(dispatch, /* Reset */0);
                    }),
                  submitCb: (function (param) {
                      return Curry._1(toggleConfirmationModal, (function (param) {
                                    return /* Update */0;
                                  }));
                    })
                });
            break;
        
      }
    } else {
      tmp = state.TAG === /* PrioritiseError */0 ? React.createElement(React.Fragment, undefined, React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "c-footer-error-message"
                }, React.createElement("img", {
                      src: error_sign
                    }), state._0._0.message), React.createElement(ModificationListViewFooter$ActionButtons, {
                  resetCb: (function (param) {
                      Curry._1(reset_list, undefined);
                      return Curry._1(dispatch, /* Reset */0);
                    }),
                  submitCb: (function (param) {
                      return Curry._1(toggleConfirmationModal, (function (param) {
                                    return /* Reprioritize */1;
                                  }));
                    })
                })) : React.createElement(React.Fragment, undefined, React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "c-footer-error-message"
                }, React.createElement("img", {
                      src: error_sign
                    }), state._0._0.message), React.createElement(ModificationListViewFooter$ActionButtons, {
                  resetCb: (function (param) {
                      Curry._1(reset_list, undefined);
                      return Curry._1(dispatch, /* Reset */0);
                    }),
                  submitCb: (function (param) {
                      return Curry._1(toggleConfirmationModal, (function (param) {
                                    return /* Update */0;
                                  }));
                    })
                }));
    }
  }
  var tmp$1;
  if (action !== undefined) {
    var func = getActionCb(action, reset_list, match$1.refetchModifications, core_pricing_external_id, match$2.openSnackbar, (function (param) {
            return Curry._1(toggleConfirmationModal, (function (param) {
                          
                        }));
          }), dispatch);
    tmp$1 = React.createElement(UpdateModificationConfirmationModal.make, {
          isOpen: true,
          onConfirmCb: (function (param) {
              return Curry._2(func, param, country);
            }),
          onCancelCb: (function (param) {
              return Curry._1(toggleConfirmationModal, (function (param) {
                            
                          }));
            }),
          action_type: action
        });
  } else {
    tmp$1 = null;
  }
  return React.createElement("div", {
              className: "c-modification-lst-footer"
            }, tmp, tmp$1);
}

var make = ModificationListViewFooter;

export {
  error_sign ,
  ActionButtons ,
  getErrorString ,
  getEditedModificationPayload ,
  getReprioritizeModificationsPayload ,
  getActionCb ,
  make ,
  
}
/* error_sign Not a pure module */
